import { Injectable } from "@angular/core";

export interface Notification {
  content: string;
}

@Injectable({
  providedIn: "root",
})
export class NotifService {
  public stack: Notification[] = [];
  constructor() {}

  public push(content: string): void {
    this.stack.push({
      content: content,
    });
  }

  public close(index: number): void {
    this.stack.splice(index, 1);
  }
}
